(function () {
  var config = document.querySelector('[data-bb-offer-media]');
  if (!config) return;
  var media = JSON.parse(config.textContent);
  var originals = new WeakMap();
  var attributes = ['src', 'srcset', 'alt', 'data-max-resolution'];
  function updateImage(image, variant) {
    var original = originals.get(image);
    if (!original) {
      var filename = new URL(image.src, window.location.href).pathname.split('/').pop();
      var rule = media.find(function (entry) { return entry.sources.indexOf(filename) !== -1; });
      if (!rule) return;
      original = { rule: rule, attributes: {} };
      attributes.forEach(function (name) { original.attributes[name] = image.getAttribute(name); });
      originals.set(image, original);
    }
    var replacement = original.rule.variants[variant];
    attributes.forEach(function (name) {
      var value = original.attributes[name];
      if (replacement) {
        if (name === 'src' || name === 'data-max-resolution') value = replacement.src;
        if (name === 'alt') value = replacement.alt;
        if (name === 'srcset') value = null;
      }
      if (image.getAttribute(name) === value) return;
      if (value === null) image.removeAttribute(name);
      else image.setAttribute(name, value);
    });
  }
  document.addEventListener('avvi:buybox:change', function () {
    var variant = window.avviBuybox.current();
    document.querySelectorAll('[data-bb-gallery] img').forEach(function (image) { updateImage(image, variant); });
    document.querySelectorAll('[data-bb-copy]').forEach(function (element) {
      var text = element.getAttribute('data-' + variant);
      if (text !== null && element.textContent !== text) element.textContent = text;
    });
  });
})();
